import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export const FeedstockQualityPanelStyled = styled(Stack)({
  display: "flex",
  height: "calc(100vh - 70px)",
  justifyContent: "stretch",
  alignItems: "center",
  "> iframe": {
    alignSelf: "stretch",
    width: "100%",
    height: "100%",
  }
});

export const FeedstockQualityMainStyled = styled("main")(() => {
  return {
    height: "100%",
    width: "100%",
    "@media (min-width: 1280px)": {
      margin: "24px 100px 80px ",
    },
  };
});

export const FeedstockQualityTitleStyled = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: theme.spacing(4),
  color: theme.palette.institutional.braskemGray
}));
